import styled, { css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Title, Box, Switcher } from "@similarweb/ui-components";

import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const MMXAlertWrapper = styled.div`
    margin-top: 3px;
    align-self: center;
    margin-left: 2px;
`;

export const StyledHeaderTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 20px;
    ${InfoIcon} {
        line-height: 1.55;
    }
`;

export const BoxSubtitleWrapper = styled.div`
    margin-top: 6px;
`;

export const StyledSwitcher = styled(Switcher)`
    height: 40px;
    margin-left: 12px;
`;

export const BoxContainer: any = styled(Box)`
    width: 100%;
    max-width: 1368px;
    border-radius: 6px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    height: 386px;
`;

export const TitleBox = styled(FlexRow)`
    justify-content: space-between;
    padding: 20px 20px;
    height: 47px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const RightSection = styled(FlexRow)`
    align-items: flex-start;
`;

export const LoaderWrapper = styled(CenteredFlexRow)`
    flex: 1;
    min-height: 345px;
`;

export const NoDataWrapper = styled(CenteredFlexRow)<{ size?: string }>`
    flex: 1;
    height: 100%;
    padding: 25px 0;
    min-height: ${(props) => (props.size === "small" ? "198px" : props.size === "large" ? "268px" : "auto")};
`;
export const ChartLabelOpenNewWindowWrapper = styled.div.attrs((props) => ({
    className: "PlainTooltip-container",
}))`
    .PlainTooltip-element {
        left: 50%;
        transform: translateX(-50%);
        min-width: 150px;
        max-width: 220px;
    }
    @media print {
        a {
            color: ${colorsPalettes.sky[500]};
            text-decoration: none;
        }
    }
`;

export const LegendsWrapper = styled(FlexRow)`
    margin: 24px 24px 24px 21px;
    justify-content: space-between;
`;

export const AllTrafficContainerSingleMode = styled(FlexRow)<{ isWWO: boolean }>`
    justify-content: space-between;
    padding: 0 24px;
    > div:first-child {
        ${({ isWWO }) =>
            isWWO
                ? css`
                      width: 100%;
                  `
                : css`
                      width: calc(80% - 60px);
                  `};
        padding: 25px 20px 16px 16px;
        .highcharts-axis-labels {
            span {
                font-size: 14px;
            }
        }
    }
    > div:last-child {
        margin: 20px 0 24px 0;
    }
`;

export const LegendsSingleWrapper = styled(FlexRow)`
    margin-top: 10px;
`;

export const TotalTrafficTitle = styled.div`
    font-size: 14px;
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
    margin-right: 12px;
`;

export const LegendTotalAllTraffic = styled(FlexRow)`
    font-size: 14px;
    font-weight: 500;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    padding-top: 13px;
    justify-content: space-between;
    margin-top: 10px;
`;
export const LegendContainerAllTraffic = styled.div`
    padding: 8px 0 0 0;
    width: 100%;
    > div {
        margin-bottom: 13px;
    }
`;
export const TotalTrafficNumber = styled.div`
    color: ${colorsPalettes.carbon[500]};
    font-size: 24px;
`;

export const ChannelsOverviewBarChartWrapper = styled.div`
    padding: 0 16px 16px 16px;
    box-sizing: border-box;
    .highcharts-axis-labels {
        span {
            z-index: 2;
        }
    }
`;

export const StyledBoxContainer: any = styled(BoxContainer)`
    height: fit-content;
`;

export const DiscoverMoreBtnWrapper: any = styled.a`
    padding: 0 16px 16px 16px;
`;
export const WidgetFooterContainer = styled.div`
    height: 51px;
    border-top: 1px solid ${colorsPalettes.carbon["50"]};
    padding-right: 24px;
    padding-left: 24px;
    display: flex;
    flex-direction: row-reverse;
    flex-shrink: 0;
    align-items: center;
`;

export const ChartContainer = styled(FlexRow)`
    margin-top: 32px;
`;

export const ViewByDomainChrtContainer = styled.div`
    margin-top: 32px;
`;
